import { sdkRequest } from '@eventbrite/http';
import { getOnlineEventsOption } from '@eventbrite/location-autocomplete';

export interface FormattedLocationResponse {
    currentPlace?: string;
    currentPlaceParent?: string;
    latitude?: number;
    longitude?: number;
    slug?: string;
    placeType?: string;
    placeId?: string;
    isOnline?: boolean;
    country?: string;
    countrySlug?: string;
}

export interface LocationResponse {
    place: {
        derived_ancestor_type: 'country' | 'region' | 'continent';
        name: string;
        country_iso_code: string;
        longitude: number;
        parent_id: string;
        place_type: string;
        latitude: number;
        localizations: {
            default: {
                country: {
                    location_slug: string | null;
                    suggested_abbreviation: string;
                    full_name: string | null;
                };
                region: {
                    location_slug: string | null;
                    suggested_abbreviation: string;
                    full_name: string | null;
                };
                continent: {
                    location_slug: string | null;
                    suggested_abbreviation: string | null;
                    full_name: string | null;
                };
                locality: {
                    location_slug: string | null;
                    suggested_abbreviation: string | null;
                    full_name: string | null;
                };
            };
            en_US: {
                country: {
                    location_slug: string | null;
                    suggested_abbreviation: string | null;
                    full_name: string | null;
                };
                region: {
                    location_slug: string | null;
                    suggested_abbreviation: string | null;
                    full_name: string | null;
                };
                continent: {
                    location_slug: string | null;
                    suggested_abbreviation: string | null;
                    full_name: string | null;
                };
                locality: {
                    location_slug: string | null;
                    suggested_abbreviation: string | null;
                    full_name: string | null;
                };
            };
        };
        location_slug: string;
        id: string;
        region_iso_code: string | null;
    };
}

const formatLocation = (
    location: LocationResponse,
): FormattedLocationResponse => ({
    currentPlace: location.place.name,
    currentPlaceParent:
        location?.place?.localizations?.default?.[
            location.place.derived_ancestor_type
        ]?.suggested_abbreviation || undefined,
    latitude: location.place.latitude,
    longitude: location.place.longitude,
    slug: location.place.location_slug,
    placeType: location.place.place_type,
    placeId: location.place.id,
    isOnline: false,
    country:
        location?.place?.localizations?.default?.country?.full_name ||
        undefined,
    countrySlug:
        location?.place?.localizations?.default?.country?.location_slug ||
        undefined,
});

const PLACE_BY_LOCATION_SLUG_URL = '/api/v3/geo/place_from_location_slug/';
export const getPlaceFromLocationSlug = (
    locationSlug: string,
): Promise<FormattedLocationResponse> => {
    if (locationSlug === 'online') {
        const onlineEventShape: FormattedLocationResponse =
            getOnlineEventsOption();
        return Promise.resolve(onlineEventShape);
    }

    return sdkRequest(
        `${PLACE_BY_LOCATION_SLUG_URL}?location_slug=${locationSlug}`,
    ).then((locationResponse: LocationResponse) =>
        formatLocation(locationResponse),
    );
};
